var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-auto h-full w-screen md:max-w-xl lg:max-w-3xl bg-gray-800 py-3"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }